const showSketch = () => {

	let ruCursorInside = document.querySelectorAll('.slider .ru_cursor-inside'),
		cursorInside = document.querySelectorAll('.slider .cursor-inside'),
		locale = document.querySelector('#locale');

	if(ruCursorInside.length) {
		ruCursorInside.forEach(function(item) {
			item.addEventListener('click', ()=>{

				document.location.href = '/' + locale.value + '/works/prehistory/' + item.id;

			})
		});
	}

	if(cursorInside.length) {
		cursorInside.forEach(function(item) {
			item.addEventListener('click', ()=>{

				document.location.href = '/' + locale.value + '/works/prehistory/' + item.id;

			})
		});
	}

}
export default showSketch;